import { ListDataTypeEnum, ListValue } from 'views/backoffice/CustomLists/types';

export const getFilteredValues = (valuesToSearchIn: ListValue[], listDatatype: ListDataTypeEnum | undefined, valueToSearchFor: string) =>
    valuesToSearchIn.filter(
        (opt) =>
            (listDatatype === 'Value' && opt.value.toLowerCase().includes(valueToSearchFor.toLowerCase())) ||
            (listDatatype === 'User' &&
                `${opt.userValue?.firstName?.toLowerCase()} ${opt.userValue?.lastName.toLowerCase()}`.includes(
                    valueToSearchFor.toLowerCase()
                )) ||
            (listDatatype === 'Object' &&
                opt.dynamicObjectValue?.objectValues
                    ?.reduce((acc, cur) => `${acc} ${cur}`, '')
                    ?.toLowerCase()
                    .includes(valueToSearchFor.toLowerCase())) ||
            (!listDatatype && opt?.name && opt.name.toLowerCase().includes(valueToSearchFor.toLowerCase()))
    );
